import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateRole from "./CreateRole";

const EditRole = () => {
  const { state } = useLocation();
  const navigate = useNavigate(),
    cb = async (res) => {
      res.payload.success === true && navigate(-1);
    };

  const stateModel = useMemo(
    (_) => ({
      name: state?.name,
      permissions: state?.permissions
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state?.editable]
  );

  return (
    <CreateRole
      {...{
        editable: state?.editable,
        stateModel,
        cb,
      }}
    />
  );
};

export default EditRole;
